import EffectCollector from 'side-effects/effectCollector'

const effects = ({ question_id, answer }) => {
  const effectCollector = new EffectCollector()

  if (
    question_id === 'child_care_and_parenting_concerns' &&
    (answer === 'NO' || answer === null)
  ) {
    effectCollector.add('child_care_problems', [])
    effectCollector.add('child_care_explain', null)
  }

  if (question_id === 'child_care_problems' && !answer.includes('Othr')) {
    effectCollector.add('child_care_explain', null)
  }

  return effectCollector.effects
}

export default effects